import Link from "next/link";
import { FiChevronRight } from "react-icons/fi";
import Script from "next/script";
import breadCrumbList from "@/utils/getBreadCrumbList";

const Breadcrumbs = ({ dark = false, page }) => {
  const breadcrumbs = breadCrumbList(page);
  const { parent, child, grandChild } = breadcrumbs;
  if (!breadcrumbs.parent) return;

  return (
    <div>
      {generateSchema(parent, child, grandChild)}
      <div className="custom_breadcrumb bg-transparent py-[12px] ">
        <div className="flex justify-start items-center gap-x-[4px] md:gap-x-[12px] flex-wrap">
          <Link
            href={"/"}
            className={`text-[16px] md:text-[18px] ${dark ? "text-black" : "text-white"} `}
          >
            Home
          </Link>
          {parent?.link && (
            <>
              <div>
                <FiChevronRight
                  size={20}
                  color={`${dark ? "black" : "white"}`}
                />
              </div>
              <Link
                href={parent?.link}
                className={`text-[16px] md:text-[18px] ${child?.link || grandChild?.link ? (dark ? "text-black" : "text-white") : "text-[#EEB978]"}`}
              >
                {parent?.label}
              </Link>
            </>
          )}
          {child?.link && (
            <>
              <div>
                <FiChevronRight
                  size={20}
                  color={`${dark ? "black" : "white"}`}
                />
              </div>
              <Link
                href={child?.link}
                className={`text-[16px] md:text-[18px] ${grandChild?.link ? "text-[#ffffff]" : "text-[#EEB978]"}`}
              >
                {child?.label}
              </Link>
            </>
          )}
          {grandChild?.link && (
            <>
              <div>
                <FiChevronRight
                  size={20}
                  color={`${dark ? "black" : "white"}`}
                />
              </div>
              <Link
                href={grandChild?.link}
                className={`text-[16px] md:text-[18px] text-[#EEB978] `}
              >
                {grandChild?.label}
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Breadcrumbs;

const generateSchema = (parent, child, grandChild) => {
  let itemListElement = [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://accidentnewyork.com/",
    },
  ];
  if (parent?.link) {
    itemListElement.push({
      "@type": "ListItem",
      position: 2,
      name: parent?.label,
      item: `https://accidentnewyork.com${parent?.link}`,
    });
  }
  if (child?.link) {
    itemListElement.push({
      "@type": "ListItem",
      position: 3,
      name: child?.label,
      item: `https://accidentnewyork.com${child?.link}`,
    });
  }
  if (grandChild?.link) {
    itemListElement.push({
      "@type": "ListItem",
      position: 4,
      name: grandChild?.label,
      item: `https://accidentnewyork.com${grandChild?.link}`,
    });
  }

  const s = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    itemListElement,
  };
  return (
    <Script
      id="breadcrumbs-schema"
      type="application/ld+json"
      data-nscript="beforeInteractive"
    >
      {JSON.stringify(s)}
    </Script>
  );
};
